module.exports = __webpack_public_path__ + "static/media/icon-snow.696ecb5c.svg";